module.exports = __webpack_public_path__ + "static/media/vendors.2b4f714c.svg";